import {DrillHoleConfiguration} from "@/Models/DrillHoleConfigurations/DrillHoleConfiguration";

export default class NullDrillHoleConfiguration implements DrillHoleConfiguration {
	get_input_keys(): string[] {
		return [];
	}
}
